import React from 'react';
import { components } from 'react-select';
const { Input } = components;

const renderInput = (Component = Input) => {
  const InputWrapper = (inputProps) => (
    <Component {...inputProps} isHidden={false} autoComplete="nope" />
  );

  InputWrapper.displayName = 'InputWrapper';

  return InputWrapper;
};

export default renderInput;
